import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=68bbfcd2&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=68bbfcd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bbfcd2",
  null
  
)

export default component.exports